import { createContext, useContext } from 'react';
import type { OpenReports } from './openReports';

/**
 * The unread alert count, the Alerts badge's number. Read and corrected
 * exactly as the open report count is: once by the shell, then by the page
 * after its own load and after each mark read. D14.
 */
export const UnreadAlertsContext = createContext<OpenReports>({ count: null, set: () => {} });

export const useUnreadAlerts = () => useContext(UnreadAlertsContext);
